import React, { useState } from 'react'
import { FaInfoCircle, FaTimes } from 'react-icons/fa'
import GaugeMetric, { convertMetricName } from '../../../GaugeMetric'
import {
  GaugeCardContainer,
  GaugeCardInner,
  GaugeCardFront,
  GaugeCardBack,
  CardHeader,
  BackContent,
} from '../ModelPerformanceCard.styles'
import { getMetricColor, getMetricInfo } from '../../../../utils/metricThresholds'

interface GaugeMetricCardProps {
  metricKey: string
  value: number
}

const GaugeMetricCard: React.FC<GaugeMetricCardProps> = ({ metricKey, value }) => {
  const metricName = convertMetricName(metricKey)
  // Determine color based on the metric value and thresholds
  const initialColor = getMetricColor(metricName, value)

  const [isFlipped, setIsFlipped] = useState(false)
  const [currentColor, setCurrentColor] = useState(initialColor)
  const metricInfo = getMetricInfo(metricName)

  return (
    <GaugeCardContainer>
      <GaugeCardInner $isFlipped={isFlipped}>
        <GaugeCardFront $color={currentColor}>
          <CardHeader>
            <h5>{metricName}</h5>
            <button onClick={() => setIsFlipped(true)} aria-label="Show metric information">
              <FaInfoCircle size={16} />
            </button>
          </CardHeader>

          <div className="gauge-container">
            <GaugeMetric
              metricName={metricKey}
              metricValue={value}
              hideTitle
              onColorChange={setCurrentColor}
            />
          </div>
        </GaugeCardFront>

        <GaugeCardBack $color={currentColor}>
          <BackContent>
            <CardHeader>
              <h5>{metricInfo.title}</h5>
              <button onClick={() => setIsFlipped(false)} aria-label="Return to gauge view">
                <FaTimes size={16} />
              </button>
            </CardHeader>
            <p>{metricInfo.description}</p>
          </BackContent>
        </GaugeCardBack>
      </GaugeCardInner>
    </GaugeCardContainer>
  )
}

export default GaugeMetricCard
